import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('../layouts/MainLayout.vue'),
      },
      {
        path: '/release',
        props: true,
        component: () => import('../../src/pages/DownloadPage.vue'),
        name: 'DownloadPage'
      },
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/noauth',
    name: 'NoAuth',
    component: () => import('../../src/pages/global/Error401.vue')
  },
  {
    path: '*',
    component: () => import('../../src/pages/global/Error404.vue')
  }
]

const router = new VueRouter({
  routes
});

export default router;